import StockTransactionCrud from './StockTransactionCrud'
export {StockTransactionCrud}
export default StockTransactionCrud
